var styles = {"tend-ui-spinner":"tend-ui-spinner","tend-ui-spinner-loading":"tend-ui-spinner-loading","tend-ui-spinner-size-xs":"tend-ui-spinner-size-xs","tend-ui-spinner-size-small":"tend-ui-spinner-size-small","tend-ui-spinner-size-medium":"tend-ui-spinner-size-medium","tend-ui-spinner-size-large":"tend-ui-spinner-size-large"};

export { styles as default };
